import React, { useEffect } from 'react';
import { CContainer } from '@coreui/react-pro';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGuestContentManagements } from '../../../containers/guest/action';

const SellingGroupBanner = () => {
     const dispatch = useDispatch();
     const contentManagements = useSelector((state) => state.subscriber.contentManagements);

     const fetchDataContentManagements = () => {
          if (!contentManagements.length) {
               dispatch(fetchGuestContentManagements());
          }
     };

     useEffect(fetchDataContentManagements, []); // eslint-disable-line react-hooks/exhaustive-deps
     const pageSellingGroupNotifyContent = contentManagements.find((content) => content.key === 'pageSellingGroupNotifyContent');

     return (
          <section className="notify-banner">
               <CContainer>
                    <div className="notify-banner_content" dangerouslySetInnerHTML={{ __html: pageSellingGroupNotifyContent?.value }}></div>
               </CContainer>
          </section>
     );
};

export default SellingGroupBanner;
